/**
 * @author Simeon Artamonov <simeon@cross-works.co.uk>
 * @company Cross Works Ltd
 */
import './assets/scss/main.scss'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

// Import the router instance directly
import router from './router'

// Create Pinia instance
const pinia = createPinia()

// Create and mount the Vue application
const app = createApp(App)
app.use(router)
app.use(pinia)
app.mount('#app')
